<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdToolsInfoResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      with-custom-row-actions-first-column
                                      enable-over-check
                                      :custom-form-class="customFormClass"
                                      ref="emTable" import-enabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                        <em-button
                                                type="search"
                                                class="btn btn-outline-primary btn-sm"
                                                custom-icon="fa fa-solid fa-ban"
                                                customLabel="报废"
                                                :enabled="$_overChecked"
                                                :busy="initiateLoading"
                                                @click="initiateScrapProcess">
                                        </em-button>
                                    </div>

                                    <stock-task-print
                                            :selected-items="selectedRows"
                                            :tag-business-code="4"
                                            :tag-material-code="1"
                                            :request-param="dynamicRequestParam"
                                            @refresh="handleSuccess"
                                            @taskCreatedSuccess = "handleGoto"
                                    />
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button
                                                type="gotoChild"
                                                class="btn btn-outline-primary btn-sm"
                                                customLabel="查看工序上挂详情"
                                                @click="gotoToolsRelatePage(customRowScope.row)">
                                        </em-button>
                                        <em-button
                                                type="edit" custom-icon="fa fa-fw fa-lg fa-link"
                                                v-bind:class="'btn btn-outline-primary btn-sm'"
                                                custom-label="epc操作"
                                                @click="operateEpcCode(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <epc-bind-dialog
                :visible.sync="showEpcDialog"
                :bind-id="currentBindId"
                @success="handleSuccess"
                :tag-business-code=4
        />
    </div>
</template>
<script>
// Author Liang Gang Qiang
// Date 2022-01-14 17:50:04

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import EpcBindDialog from "@/components/em/EmEpc/EmBindEpcComponent.vue";
import browserPrint from "@/mixin/common/browserPrinter-mixin";
import StockTaskPrint from "@/components/em/EmEpc/StocktakeTaskAndPrint.vue";
import {trim} from "lodash";

export default {
    name: "sithMesPrdToolsInfoListView",
    components: {StockTaskPrint, EpcBindDialog},
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonGotoMixin, emTableCheckedMixin,browserPrint],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        selectedRows() {
            return this.selectedItems;
        },
        dynamicRequestParam() {
            let requestParam = []
            for (let i = 0; i < this.selectedItems.length; i++) {
                requestParam.push({
                    "arcName": trim(this.selectedItems[i].name),
                    "arcCode": trim(this.selectedItems[i].code),
                    "arcSize": trim(this.selectedItems[i].size),
                    "arcUnit": trim(this.selectedItems[i].unit),
                    "expectedBin": trim(this.selectedItems[i].area)+'-'+trim(this.selectedItems[i].bin),
                    "expectedQuantity": trim(this.selectedItems[i].quantity),
                    "epcCode": trim(this.selectedItems[i].epcCode)
                })
            }
            return requestParam;
        }
    },
    data() {
        return {
            customFormClass: (col, row) => {
                if (col.key === 'hasConflict' && row.hasConflict === 1) {
                    return 'bg-danger text-white';
                }
                return '';
            },
            initiateLoading: false,
            showEpcDialog: false,
            currentBindId: 0,
            loading:false,
        }
    },
    methods: {
        //跳转工装上挂页面
        gotoToolsRelatePage(row) {
            this.$store.dispatch('routeStore/addContent', {key: 'toolsId', value: row.id});
            this.$_emGotoMixin_gotoHolderList("sithMesPrdToolsRelateOperation"
                    , {toolsIdFilter: row.id, toolsNameFilter: row.name}
                    , {toolsId: row.id, toolsName: row.name}, false, {});
        },
        handleGoto(response) {
            this.$_emGotoMixin_gotoHolderList("emStocktakingTask"
                    , {taskCodeFilter: response}
                    , {taskCode: response}
                    , false, {})
        },
        initiateScrapProcess() {
            if (this.$_overChecked) {
                this.initiateLoading = true;
                let ids = this.overCheckedIds.join(",");
                this.$store.dispatch('api/post', {
                    url: `${process.env.VUE_APP_EM_ARCHIVE_URL}/emArchScrapProcessAsp/initiate?type=TOOLS&ids=${ids}`,
                    data: {},
                }).then(() => this.$message.success("发起成功"))
                        .finally(() => this.initiateLoading = false);
            }
        },
        operateEpcCode(row) {
            this.currentBindId = row.id;
            this.showEpcDialog = true;
        },
        handleSuccess() {
            this.$refs.emListFilter.doQuery();
        },
    }
};
</script>
